import { tns } from '../../_scripts/plugins/tiny-slider/tiny-slider.js';

export default class JournalSlider {

  constructor() {
    this.journalList = document.querySelector('.journal__list--slider');
    this.sliderNav = document.querySelector('.slider__nav');
    this.journalItemAll = document.querySelectorAll('.journal__item');
    this.slider;
  }

  _removeActiveSlide() {
    [...this.journalItemAll].map(link => {
      link.classList.remove('journal__item--slide-active');
    });
  }

  _activeSlide(target) {
    this._removeActiveSlide();

    const currentItem = target.closest('.journal__item');
    currentItem.classList.add('journal__item--slide-active');
    this._getNumberSlide(currentItem);
  }

  _getNumberSlide(currentItem) {
    let slideNumber = Number(currentItem.closest('.journal__item').getAttribute('id').match(/\d+/g)[1]);
    this.slider.goTo(slideNumber);
  }

  _tinySlider() {
    const slider = tns({
      autoWidth: true,
      loop: false,
      slideBy: 'page',
      mouseDrag: true,
      container: this.journalList,
      controlsContainer: this.sliderNav,
      swipeAngle: false,
      speed: 400,
      gutter: 40,
      nav: false,
      autoPlay: false,
      responsive: {
        1024: {
          mouseDrag: false
        }
      }
    });

    this.slider = slider;
  }

  init() {

    if (this.journalList) {
      this._tinySlider();
    }

    if (this.journalList) {
      this.journalList.addEventListener('click', e => {
        e.target.closest('.journal__item')
          ? this._activeSlide(e.target)
          : e.preventDefault();
      });
    }
  }
}